import queryString from 'query-string';

const BASE_URL = window.location.origin;

class RecruitApiClient {
  getHeaders(headers: { 'X-api-authenticate': string } | null) {
    return Object.assign(
      {},
      {
        'Content-Type': 'application/json'
      },
      headers
    );
  }

  handleResponse = async (response: any) => {
    if (response.ok) {
      const resHead: { [key: string]: string } = {};
      [...response.headers].forEach(
        (header) => (resHead[header[0] as keyof typeof resHead] = header[1])
      );
      const text = await response.text();
      const data = text ? JSON.parse(text) : null;
      return { res: data, resHead: resHead };
    }
    return response.json().then((error: any) => {
      error.code = response.status;
      throw error;
    });
  };

  get = <T,>(
    path: string,
    params: any = null,
    headers: { 'X-api-authenticate': string } | null = null,
    download?: boolean
  ): Promise<{ res: T; resHead: { [key: string]: string } }> =>
    fetch(
      `${BASE_URL}${path}${params ? `?` : ''}${queryString.stringify(params, {
        arrayFormat: 'bracket',
        encode: false
      })}`,
      {
        headers: this.getHeaders(headers)
      }
    ).then((r) => {
      if (download) return r.blob();
      return this.handleResponse(r);
    });
  post = <T,>(
    path: string,
    params = {},
    headers: { 'X-api-authenticate': string } | null = null,
    download?: boolean
  ): Promise<{ res: T; resHead: { [key: string]: string } }> =>
    fetch(`${BASE_URL}${path}`, {
      headers: this.getHeaders(headers),
      method: 'POST',
      body: JSON.stringify(params)
    }).then((r) => {
      if (download) return r.blob();
      return this.handleResponse(r);
    });

  put = <T,>(
    path: string,
    params = {},
    headers: { 'X-api-authenticate': string } | null = null
  ): Promise<{ res: T; resHead: { [key: string]: string } }> =>
    fetch(`${BASE_URL}${path}`, {
      headers: this.getHeaders(headers),
      method: 'PUT',
      body: JSON.stringify(params)
    }).then((r) => this.handleResponse(r));

  delete = <T,>(
    path: string,
    params = {},
    headers: { 'X-api-authenticate': string } | null = null
  ): Promise<{ res: T; resHead: { [key: string]: string } }> =>
    fetch(`${BASE_URL}${path}`, {
      headers: this.getHeaders(headers),
      method: 'DELETE',
      body: JSON.stringify(params)
    }).then((r) => this.handleResponse(r));
}

export default new RecruitApiClient();
